import type { ReadonlyDate } from '../../../../../../../utils'

import type { BackendDefinition } from '../../../../../../Connectware'

export const mapMarketplace = (
    marketplace: BackendDefinition<'service-manager', 'ServiceDetails'>['marketPlace']
): Readonly<{ directory: string, filename: string, version: string, updatedAt: ReadonlyDate }> | null =>
    marketplace.directory && marketplace.filename && marketplace.version && marketplace.updatedAt
        ? {
              directory: marketplace.directory,
              filename: marketplace.filename,
              version: marketplace.version,
              updatedAt: new Date(marketplace.updatedAt),
          }
        : null
